module.exports = __webpack_public_path__ + "img/chatgpt.562df8e6.svg";